<template>
    <v-container fluid>
        <div class="fixed-buttons">
            <div v-for="(button, index) in buttons" :key="index" class="button-wrapper">
                <v-btn v-if="button.active"
                       class="toggle-btn py-4"
                       color="gray"
                       @click="toggleExpand(button.storage,button.isOpen,index)"
                >
                    <v-icon>{{ button.isOpen ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
                </v-btn>
                <v-btn
                        v-if="button.isOpen && button.active"
                        :color="button.isOpen ? 'primary' : 'secondary'"
                        @click="emitEvent(index, button.emitEvent)"
                        class="main-button py-4"
                >
                    <v-icon class="mr-1" size="16">
                        {{ button.icon }}
                    </v-icon>
                    {{ button.label }}
                </v-btn>
            </div>
        </div>
    </v-container>
</template>

<script>
  export default {
    name: 'BotoesProposta',
    props: {
      ativaBotaoCarrinho: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        buttons: [
          {
            label: 'Voltar para o carrinho',
            isOpen: JSON.parse(localStorage.getItem('botaoVoltarCarrinhoOpen')) || true,
            emitEvent: 'toggleCarrinho',
            icon: 'mdi-cart',
            storage: 'botaoVoltarCarrinhoOpen',
            active: false
          },
          {
            label: 'Voltar para Minhas Vendas',
            isOpen: JSON.parse(localStorage.getItem('botaoVoltarMinhasVendasOpen')) || true,
            emitEvent: 'toggleVendas',
            icon: 'mdi-file-document',
            storage: 'botaoVoltarMinhasVendasOpen',
            active: true
          }

        ]
      }
    },
    watch: {
      ativaBotaoCarrinho (newVal) {
        this.buttons[0].active = newVal
      }
    },
    mounted () {
      this.buttons[0].active = this.ativaBotaoCarrinho
    },
    methods: {
      emitEvent (index, emitEvent) {
        this.$emit(emitEvent, this.buttons[index].isOpen)
      },
      toggleExpand (storage, value, index) {
        this.buttons[index].isOpen = !this.buttons[index].isOpen
        localStorage.setItem(storage, JSON.stringify(!value))
      }
    }
  }
</script>

<style>
.fixed-buttons {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.button-wrapper {
  display: flex;
  align-items: center;
  transition: transform 0.3s ease; /* Transição suave para o movimento */
  justify-content: flex-end; /* Alinha os itens à direita */
}

.main-button {
  width: 20rem; /* Ajuste este valor de acordo com o tamanho desejado */
  height: 40px; /* Ajuste este valor de acordo com o tamanho desejado */
  display: flex;
  align-items: center;
  padding-left: 10px !important;
  justify-content: start;
}

.main-button {
  transition: margin 0.3s ease;
  margin-right: -8px; /* Ajuste a margem para o botão principal */
  overflow: hidden; /* Garante que não haja transbordamento visual */
  border-radius: 0px !important;
}

.toggle-btn {
  min-width: 45px !important;
  width: 40px;
  border-radius: 5px 0px 0px 5px !important;
  background-color: var(--neutral); /* Cinza */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.toggle-btn:hover {
  background-color: #9e9e9e; /* Cinza mais escuro quando hover */
}
</style>
